module.exports = __webpack_public_path__ + "img/knowlagebase-app.671ceafe.png";